module.exports = {"longVersion":"v0.3.0-31-g88f32ab","longHash":"88f32ab27cf660d65b6a530e5c98ee1b52b9f9d7","shortHash":"88f32ab","date":1516327604000}


//////////////////
// WEBPACK FOOTER
// ../core/lib/version.json
// module id = 758
// module chunks = 0